import { Box, Column, Divider, GridContainer, Link, ResponsiveImage, Row, tokens } from '@vp/swan'
import { useTranslation } from 'react-i18next'
import LeftArrowIcon from '../../assets/images/left_arrow.svg'
import { Article } from '../../types/article.type'
import { ArticleContent } from '../article-content/ArticleContent'
import { RelatedArticles } from '../relatedArticles/RelatedArticles'
import { FeedbackComponent } from '@vp/feedback-ui'
import { useIdentity } from '@vp/ubik-context'
import { useArticleVote } from '../../hooks/useArticleVote'
import { useState } from 'react'

interface ArticleProps {
  locale: string
  tenant: string
  article: Article
  handleBackBtnClick: () => void
}

export const ArticleView = (props: ArticleProps) => {
  const { locale, tenant, article, handleBackBtnClick } = props
  const [showDivider, setShowDivider] = useState(false)
  const lng = locale.toLowerCase().replace('-', '_')
  const identity = useIdentity()
  const { data } = useArticleVote(article.sfId, locale)
  const { t } = useTranslation(tenant)

  const handleRender = (isShown: boolean) => {
    setShowDivider(isShown)
  }

  return (
    <>
      <GridContainer>
        <Row>
          <Column span={2} spanXs={12} spanSm={12} spanMd={2} spanLg={2}>
            <Row>
              <Link
                fontWeight="bold"
                skin="unstyled"
                href="#"
                onClick={handleBackBtnClick}
                style={{ padding: `${tokens.SwanSemSpaceBetweenSections} ${tokens.SwanSemSpaceGutterStandard} 0px ${tokens.SwanSemSpaceGutterStandard}` }}
              >
                <Box mr="3" style={{ display: 'inline-flex' }}>
                  <ResponsiveImage role="presentation" src={LeftArrowIcon} alt="" height="10px" />
                </Box>
                {t(`${props.tenant}:articles.links.back`, { lng })}
              </Link>
            </Row>
            <Row display={{ lg: 'none', md: 'none', sm: 'none' }} marginTop={8} />
            <Row display={{ xs: 'none', sm: 'block', md: 'block' }} marginTop={9} />
          </Column>
          <Column span={7} spanXs={12} spanSm={12} spanMd={7} spanLg={7} mt={8} pl={4}>
            <Row ml="0">
              <ArticleContent article={article} />
            </Row>

            {showDivider && <Divider mt="9" />}
            <Row py="8" ml="0">
              <FeedbackComponent
                locale={locale}
                onRender={handleRender}
                origin="HelpCenterArticle"
                previousVote={data?.upvote ? 'upVote' : data?.upvote === false ? 'downVote' : undefined}
                trackingData={{ category: 'Help Center:Article Page' }}
                articleData={{
                  articleId: article.sfId,
                  knowledgeKavId: article.knowledgeKavId,
                  articleTitle: article.articleTitle,
                  articleNumber: article.articleNumber,
                  articleVersion: article.articleVersion,
                }}
                auth={identity.auth!}
              />
            </Row>
          </Column>
          {article.relatedArticles.length > 1 ? (
            <Column span={3} spanXs={12} spanSm={12} spanMd={3} spanLg={3}>
              <RelatedArticles tenant={tenant} locale={locale} relatedArticles={article.relatedArticles} />
              <Row display={{ lg: 'none', md: 'none', xs: 'none', sm: 'block', xl: 'block' }} marginTop={10} />
              <Row display={{ lg: 'none', md: 'none', sm: 'none' }} marginTop={9} />
              <Row display={{ sm: 'none', xs: 'none', md: 'block' }} marginTop={11} />
            </Column>
          ) : null}
        </Row>
        <Row display={{ lg: 'none', md: 'none', sm: 'none' }} marginTop={10} />
        <Row display={{ lg: 'none', md: 'none', xs: 'none', sm: 'block', xl: 'block' }} marginTop={11} />
      </GridContainer>
    </>
  )
}
